// extracted by mini-css-extract-plugin
export var actionButton = "_g9-0";
export var attachmentLine = "_g9-1";
export var fileInput = "_g9-2";
export var fileUploadWrapper = "_g9-4";
export var footer = "_g9-3";
export var modalContent = "_g9-5";
export var paperclip = "_g9-6";
export var quillEditor = "_g9-7";